import config from 'config/config'
import { I18n } from 'lib/i18n'
import { get } from 'lib/utilities'
import { toast } from 'react-toastify'
import routes from 'src/redux/routes.yaml'

const TOGGLE_SIDEBAR = 'navigation/TOGGLE_SIDEBAR'
const HIDE_LOGOUT_MODAL = 'navigation/HIDE_LOGOUT_MODAL'
const SHOW_LOGOUT_MODAL = 'navigation/SHOW_LOGOUT_MODAL'
const HIDE_SIDEBAR = 'navigation/HIDE_SIDEBAR'
const SET_PATH = 'navigation/SET_PATH'
const SET_NODE = 'navigation/SET_NODE'
const SET_TITLE = 'navigation/SET_TITLE'
const SET_DIRTY_STATE = 'navigation/SET_DIRTY_STATE'
const CONFIRMATION_MODAL = 'navigation/CONFIRMATION_MODAL'
const CONFIRM = 'navigation/CONFIRM'
const CANCEL_CONFIRM = 'navigation/CANCEL_CONFIRM'
const LOAD_BADGES = 'navigation/LOAD_BADGES'
const LOAD_BADGES_DONE = 'navigation/LOAD_BADGES_DONE'
const LOAD_BADGES_FAILED = 'navigation/LOAD_BADGES_FAILED'

export const toggleSidebar = () => ({ type: TOGGLE_SIDEBAR })
export const hideSidebar = () => ({ type: HIDE_SIDEBAR })
export const showLogoutModal = () => ({ type: SHOW_LOGOUT_MODAL })
export const hideLogoutModal = () => ({ type: HIDE_LOGOUT_MODAL })
/*
export const setPath = (path, pageTitle, calledFromSetNode) => ({ type: SET_PATH, path, pageTitle, calledFromSetNode });
export const setNode = (node, calledFromSetPath) => {
  toast.error('setNode was called');
  return ({ type: SET_NODE, node, calledFromSetPath });
};
*/
export const setDirtyFormState = (dirtyForm) => ({
  type: SET_DIRTY_STATE,
  dirtyForm,
})
export const confirmationModal = (modal) => ({
  type: CONFIRMATION_MODAL,
  modal: modal,
})
export const confirm = () => ({ type: CONFIRM })
export const cancelConfirm = () => ({ type: CANCEL_CONFIRM })
export const loadBadges = () => ({ type: LOAD_BADGES })
export const loadBadgesDone = (badges) => ({ type: LOAD_BADGES_DONE, badges })
export const loadBadgesFailed = (errors) => ({
  type: LOAD_BADGES_FAILED,
  errors,
})

const initialState = {
  pageTitle: I18n.t('global.company_name'),
  language: config.navigation.defaultLanguage,
  languages: config.navigation.languages,
  categoriesVisible: true,
  floatNavVisible: false,
  sidebarVisible: false,
  dirtyForm: false,
  siteMap: routes.filter((route) => route.path),
}

export const navigationReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOAD_BADGES:
      return { ...state, loadingBadges: true }

    case LOAD_BADGES_DONE:
      return { ...state, loadingBadges: false, badges: action.badges }

    case TOGGLE_SIDEBAR:
      return { ...state, sidebarVisible: !state.sidebarVisible }

    case HIDE_LOGOUT_MODAL:
      return { ...state, logoutModalVisible: false }

    case SHOW_LOGOUT_MODAL:
      return { ...state, logoutModalVisible: true }

    case HIDE_SIDEBAR:
      return { ...state, sidebarVisible: false, logoutModalVisible: false } // can't capture the key in the logout modal

    case SET_PATH:
      return {
        ...state,
        currentPath: action.path,
        sidebarVisible: false,
        pageTitle: action.pageTitle,
      }

    case SET_TITLE:
      return { ...state, pageTitle: action.pageTitle }

    case SET_NODE:
      return { ...state, currentNode: action.node }

    case SET_DIRTY_STATE:
      return { ...state, dirtyForm: action.dirtyForm }

    case CONFIRMATION_MODAL:
      return { ...state, confirmationModalVisible: true, modal: action.modal }

    case CANCEL_CONFIRM:
    case CONFIRM:
      return { ...state, confirmationModalVisible: false }

    default:
      return state
  }
}

export const loadBadgesEpic = (action$, store) =>
  action$
    .ofType(LOAD_BADGES)
    .mergeMap((action) => get('/badges.json'))
    .mergeMap((result) => {
      if (result.ok) {
        return [loadBadgesDone(result.body)]
      } else {
        toast.error(I18n.t(`action.${LOAD_BADGES_FAILED}`))
        return result && result.body && [loadBadgesFailed(result.body.errors)]
      }
    })



// WEBPACK FOOTER //
// ./src/redux/navigation.js